import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`glass-button px-8 py-3.5 text-xs md:text-sm tracking-[0.2em] uppercase font-medium rounded-full transition-all duration-500 hover:scale-[1.02] hover:border-gold/50 ${className}`} {...props} data-id="element-27">
      {children}
    </button>;
}